/* unplugin-vue-components disabled */import { render } from "./PCSelect.vue?vue&type=template&id=513d5c1b&ts=true"
import script from "./PCSelect.vue?vue&type=script&lang=ts"
export * from "./PCSelect.vue?vue&type=script&lang=ts"

import "./PCSelect.vue?vue&type=style&index=0&id=513d5c1b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__